import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {ChestType, Player} from "@/store/player/types";
import ChestStore from "@/store/chest";
import {ChestContentType, ContentDto} from "@/store/chest/types";
import {ForceUtils} from "@/utils/force-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import {Tr, TrSpace} from "@/i18n/i18n";
import CreaturePanel from "@/scenes.ui/creature-panel";
import PlayerStore from "@/store/player";
import {PickCreaturePanel} from "@/scenes.ui/pick-creature-panel";
import Sprite = Phaser.GameObjects.Sprite;
import ListenerManager from "@/managers/listener-manager";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {CardInfo, CardType} from "@/store/card/types";
import {IntroPage} from "@/scenes.ui/multiple-intro-panel";
import {IntroPanel} from "@/scenes.ui/intro-panel";
import {SoloIntroPanel} from "@/scenes.ui/solo-intro-panel";

export class CardPanel extends VerticalStandardPanel {

    completedSound: BaseSound | undefined;
    clickSound: BaseSound | undefined;
    cards:CardInfo[] | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, cards:CardInfo[], useCardCallback: (cardType:CardType) => unknown, clickSound: BaseSound | undefined,
                completedSound: BaseSound | undefined) {
        super(scene, canvas, Tr('cards'));
        this.setDepth(3002);
        this.completedSound = completedSound;
        this.clickSound = clickSound;
        this.cards = cards;

        this.init(scene, canvas, cards[0], useCardCallback);
    }

    private init(scene:Scene, canvas:HTMLCanvasElement, cardInfo:CardInfo, useCardCallback: (cardType:CardType) => unknown) : void {
        let cardType = cardInfo.cardType;
        let subtitle = cardInfo.description;
        let nameText = TextUtils.addTextByFamily(scene, subtitle, 0, -170,
            '#d3b779', 17, 'normal', 420, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, 0, -10, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, 0, -20, Keys.CARD_ELEPHANT);

        this.add([nameText, light, icon]);

        let blockSecondText = Tr('available') + ': ' + cardInfo.count + Tr('pc.');
        let blockSecond = TextUtils.addTextByFamily(scene, blockSecondText,
            0,  100, '#918f8f', 15, 'normal', 450, Fonts.ARIAL_MT);
        this.add(blockSecond);

        if(PlayerStore.GET_CARDS_STATE()?.elephantActive && cardType === CardType.ELEPHANT){
            let activeText = TextUtils.addTextByFamily(scene, Tr('card.is.active') + '!\n' + Tr('choose.hero.and.improve.force'),
                0,  180, '#77e877', 18, 'normal', 450, Fonts.ARIAL_MT);
            this.add(activeText);
        } else {
            let btn = this.addCustomButton(0, 180, Tr('ispolzovat').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_ART_UPPER_ICON, () => {
                if(cardInfo.count > 0){
                    let ip: SoloIntroPanel = new SoloIntroPanel(scene, canvas, this.getCardName(cardType).toUpperCase(), Tr('you.activated.card'),
                        undefined, this.getCardSmallImage(cardType), this.getCardTutorial(cardType), "", () => {
                            ip.close();
                        });
                    ip.openAnimated();

                    useCardCallback(CardType.ELEPHANT);
                    SoundUtils.play(this.completedSound);
                }
            });
            if(cardInfo.count == 0){
                btn.alpha = 0.5;
            }
        }
    }

    private getCardName(cardType: CardType){
        switch (cardType){
            case CardType.ELEPHANT:
                return Tr('card.elephant');
        }
        return "";
    }

    private getCardTutorial(cardType: CardType){
        switch (cardType){
            case CardType.ELEPHANT:
                return Tr('card.elephant.tutorial');
        }
        return "";
    }

    private getCardSmallImage(cardType: CardType){
        switch (cardType){
            case CardType.ELEPHANT:
                return Keys.CARD_ELEPHANT_SMALL;
        }
        return "";
    }

}
